"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowPropertiesLeafElementDestination = void 0;
var tslib_1 = require("tslib");
var destination_1 = require("../../../destination");
var TableRowPropertiesLeafElementDestination = (function (_super) {
    tslib_1.__extends(TableRowPropertiesLeafElementDestination, _super);
    function TableRowPropertiesLeafElementDestination(data, row) {
        var _this = _super.call(this, data) || this;
        _this.row = row;
        return _this;
    }
    Object.defineProperty(TableRowPropertiesLeafElementDestination.prototype, "elementHandlerTable", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    return TableRowPropertiesLeafElementDestination;
}(destination_1.ElementDestination));
exports.TableRowPropertiesLeafElementDestination = TableRowPropertiesLeafElementDestination;
